// @flow
import CompetitionDocuments from 'components/competition/CompetitionDocuments';
import { connect } from 'react-redux';

import type { StateProps } from 'components/competition/CompetitionDocuments';
import type { StateType } from 'types/Actions';

export default connect((state: StateType): StateProps => ({
  documents: state.competitionState.competition.documents.documents
}))(CompetitionDocuments);
